import { InvoiceEditorVariant } from '../../enums/invoiceEditorVariant'

export const DEFAULT_INVOICE_EDITOR_VARIANT = InvoiceEditorVariant.InvoiceNew
